{
  "familyId": "GET-KOMMA-LEZEN",
  "questions": [
    {
      "id": "GET-KOMMA-LEZEN-001",
      "familyId": "GET-KOMMA-LEZEN",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "komma_lezen_schrijven",
      "questionType": "multiple_choice",
      "question": "Hoe lees je het getal 3,07?",
      "options": [
        "drie komma nul zeven",
        "drie komma zeventig",
        "drie komma zeven",
        "dertig komma zeven"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kommagetallen lezen",
            "content": "Lees het getal vóór de komma als één geheel. Achter de komma lees je de cijfers als één getal: 0,125 = 'nul komma honderdvijfentwintig'. Let op nullen: 3,07 = 'drie komma nul zeven' (niet 'zeventig').",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "komma_lezen_nul",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.70,
      "pedagogy": {
        "dok": 1
      },
      "feedback": {
        "explanationText": "Kijk naar het getal achter de komma: 07. Er staat een 0 op de tiendenplek en een 7 op de honderdstenplek. Lees elk cijfer apart: 'nul zeven'. Samen: 'drie komma nul zeven'. Let op: 3,07 is niet hetzelfde als 3,7.",
        "solutionSteps": [
          "Lees het getal vóór de komma: 3 = 'drie'",
          "Kijk naar de cijfers achter de komma: 07",
          "Er staat een nul op de tiendenplek — lees elk cijfer apart: 'nul zeven'",
          "Samen: 'drie komma nul zeven'"
        ],
        "distractorExplanations": {
          "0": "Goed! 3,07 lees je als 'drie komma nul zeven'. De nul op de tiendenplek is belangrijk: 3,07 ≠ 3,7.",
          "1": "Je dacht waarschijnlijk dat 07 hetzelfde is als zeventig. Maar achter de komma werkt het anders: 07 zijn twee losse cijfers — nul en zeven. Onthoud: lees elk cijfer achter de komma apart als er een nul tussen staat.",
          "2": "Je dacht waarschijnlijk dat de nul niet meegeteld hoeft te worden. Maar 3,07 is niet hetzelfde als 3,7. De 0 staat op de tiendenplek en de 7 op de honderdstenplek. Onthoud: een nul achter de komma verandert de waarde van het getal.",
          "3": "Je dacht waarschijnlijk dat de komma op een andere plek staat. Maar de 3 staat vóór de komma als eenheden. Onthoud: het getal vóór de komma lees je als één geheel getal."
        }
      }
    },
    {
      "id": "GET-KOMMA-LEZEN-002",
      "familyId": "GET-KOMMA-LEZEN",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "komma_lezen_schrijven",
      "questionType": "multiple_choice",
      "question": "Welk getal hoort bij 'twaalf komma vijfentwintig'?",
      "options": [
        "12,25",
        "12,52",
        "1,225",
        "12,025"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Van woord naar cijfer",
            "content": "Splits het woord bij 'komma'. Schrijf het deel vóór de komma als heel getal. Schrijf het deel achter de komma als getal: 'vijfentwintig' = 25, niet 52 of 025.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "komma_woord_naar_cijfer",
      "variantIndex": 2,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.komma-cijfers-omdraaien", "label": "Cijfers achter de komma omgedraaid", "optionIndex": 1 },
          { "id": "get.komma-getal-voor-komma-fout", "label": "Heel getal vóór de komma verkeerd geschreven", "optionIndex": 2 },
          { "id": "get.komma-extra-nul", "label": "Extra nul toegevoegd achter de komma", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Splits het woord bij 'komma'. Het deel vóór de komma: 'twaalf' = 12. Het deel achter de komma: 'vijfentwintig' = 25 (2 tienden + 5 honderdsten). Samen: 12,25.",
        "solutionSteps": [
          "Splits bij 'komma': 'twaalf' en 'vijfentwintig'",
          "Vóór de komma: twaalf = 12",
          "Achter de komma: vijfentwintig = 25",
          "Schrijf samen: 12,25"
        ],
        "distractorExplanations": {
          "0": "Goed! Twaalf komma vijfentwintig = 12,25.",
          "1": "Je dacht waarschijnlijk dat je de cijfers achter de komma mocht omdraaien. Maar 'vijfentwintig' = 25, niet 52. Net als bij hele getallen: vijfentwintig = 25. Onthoud: de volgorde van de cijfers blijft hetzelfde.",
          "2": "Je dacht waarschijnlijk dat 'twaalf' maar één cijfer is. Maar 'twaalf' = 12 — dat zijn twee cijfers vóór de komma. Onthoud: schrijf het getal vóór de komma precies zoals je het zou schrijven als heel getal.",
          "3": "Je dacht waarschijnlijk dat 'vijfentwintig' drie cijfers heeft achter de komma. Maar 'vijfentwintig' = 25 (twee cijfers). 12,025 zou je lezen als 'twaalf komma nul vijfentwintig'. Onthoud: 'vijfentwintig' = 25, niet 025."
        }
      }
    },
    {
      "id": "GET-KOMMA-LEZEN-003",
      "familyId": "GET-KOMMA-LEZEN",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "komma_lezen_schrijven",
      "questionType": "multiple_choice",
      "question": "Hoe schrijf je 'nul komma acht' in cijfers?",
      "options": [
        "0,8",
        "0,08",
        "0,80",
        "8,0"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Van woord naar cijfer",
            "content": "'Acht' is één cijfer achter de komma = 8 tienden = 0,8. Voeg geen extra nul toe vóór de 8: 0,08 is acht honderdsten (tien keer kleiner!).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "komma_woord_naar_cijfer_tienden",
      "variantIndex": 3,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.komma-tienden-vs-honderdsten", "label": "Verwart tienden met honderdsten (extra nul)", "optionIndex": 1 },
          { "id": "get.komma-extra-nul", "label": "Onnodige nul achter laatste cijfer", "optionIndex": 2 },
          { "id": "get.komma-positie-fout", "label": "Komma op verkeerde positie", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Kijk naar het woord 'nul komma acht'. Vóór de komma staat 'nul' = 0. Achter de komma staat 'acht' = 8 tienden. Er is maar één cijfer achter de komma nodig. Schrijf: 0,8.",
        "solutionSteps": [
          "Splits bij 'komma': 'nul' en 'acht'",
          "Vóór de komma: nul = 0",
          "Achter de komma: acht = 8 (één cijfer = tienden)",
          "Schrijf samen: 0,8"
        ],
        "distractorExplanations": {
          "0": "Goed! Nul komma acht = 0,8 (acht tienden).",
          "1": "Je dacht waarschijnlijk dat je een extra nul vóór de 8 moest zetten. Maar 0,08 = acht honderdsten — dat is tien keer kleiner dan 0,8. 'Nul komma acht' heeft maar één cijfer achter de komma. Onthoud: 'acht' = één cijfer = één plek achter de komma.",
          "2": "0,80 is wiskundig gelijk aan 0,8, maar de gebruikelijke schrijfwijze is 0,8 zonder de extra nul. Onthoud: schrijf zo min mogelijk nullen achter het laatste cijfer.",
          "3": "Je dacht waarschijnlijk dat de komma op een andere plek staat. Maar bij 'nul komma acht' staat de 0 vóór de komma. 8,0 = acht komma nul = 8, niet nul komma acht. Onthoud: het getal vóór de komma is altijd het hele getal."
        }
      }
    },
    {
      "id": "GET-KOMMA-LEZEN-004",
      "familyId": "GET-KOMMA-LEZEN",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "komma_lezen_schrijven",
      "questionType": "multiple_choice",
      "question": "Welk getal is 'honderdvijf komma drie'?",
      "options": [
        "105,3",
        "1053",
        "15,3",
        "105,03"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Grote getallen met komma",
            "content": "Schrijf het getal vóór de komma als heel getal: honderdvijf = 105 (niet 15). Achter de komma: 'drie' = 3 (één cijfer). Samen: 105,3.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "komma_woord_naar_cijfer_groot",
      "variantIndex": 4,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.71,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.komma-weggelaten", "label": "Komma volledig weggelaten", "optionIndex": 1 },
          { "id": "get.komma-getal-voor-komma-fout", "label": "Heel getal vóór de komma verkeerd geïnterpreteerd", "optionIndex": 2 },
          { "id": "get.komma-extra-nul", "label": "Extra nul toegevoegd achter de komma", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Splits het woord bij 'komma'. Vóór de komma: 'honderdvijf' = 105. Achter de komma: 'drie' = 3 tienden. Schrijf samen: 105,3.",
        "solutionSteps": [
          "Splits bij 'komma': 'honderdvijf' en 'drie'",
          "Vóór de komma: honderdvijf = 105 (100 + 5)",
          "Achter de komma: drie = 3 (één cijfer = tienden)",
          "Schrijf samen: 105,3"
        ],
        "distractorExplanations": {
          "0": "Goed! Honderdvijf komma drie = 105,3.",
          "1": "Je dacht waarschijnlijk dat je de komma kon weglaten. Maar 1053 is een heel getal zonder komma. 'Honderdvijf komma drie' heeft een komma: 105,3. Onthoud: het woord 'komma' in de naam betekent dat er een komma in het getal staat.",
          "2": "Je dacht waarschijnlijk dat 'honderdvijf' hetzelfde is als 'vijftien'. Maar honderdvijf = 105 (100 + 5) en vijftien = 15. Onthoud: honderd = 100, dus honderdvijf = 105.",
          "3": "Je dacht waarschijnlijk dat 'drie' achter de komma drie cijfers zijn. Maar 'drie' = 3 tienden = één cijfer achter de komma. 105,03 lees je als 'honderdvijf komma nul drie'. Onthoud: 'drie' = 3, niet 03."
        }
      }
    },
    {
      "id": "GET-KOMMA-LEZEN-005",
      "familyId": "GET-KOMMA-LEZEN",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "komma_lezen_schrijven",
      "questionType": "multiple_choice",
      "question": "Hoe lees je het getal 0,125?",
      "options": [
        "nul komma honderdvijfentwintig",
        "nul komma één twee vijf",
        "nul komma twaalfeneenhalf",
        "honderdvijfentwintig"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Meerdere cijfers achter de komma",
            "content": "Lees de cijfers achter de komma als één getal: 125 = honderdvijfentwintig (niet 'één twee vijf'). Vóór de komma: 0 = nul. Samen: 'nul komma honderdvijfentwintig'.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "komma_lezen_duizendsten",
      "variantIndex": 5,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.68,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.komma-cijfers-los-lezen", "label": "Leest cijfers achter de komma los i.p.v. als één getal", "optionIndex": 1 },
          { "id": "get.komma-fractie-interpretatie", "label": "Verwart kommagetal met breukvorm", "optionIndex": 2 },
          { "id": "get.komma-genegeerd", "label": "Komma volledig genegeerd", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Kijk naar de cijfers achter de komma: 125. Lees ze als één getal: 125 = honderdvijfentwintig. Vóór de komma staat 0 = 'nul'. Samen: 'nul komma honderdvijfentwintig'.",
        "solutionSteps": [
          "Lees het getal vóór de komma: 0 = 'nul'",
          "Kijk naar de cijfers achter de komma: 125",
          "Lees 125 als één getal: honderdvijfentwintig",
          "Samen: 'nul komma honderdvijfentwintig'"
        ],
        "distractorExplanations": {
          "0": "Goed! 0,125 lees je als 'nul komma honderdvijfentwintig'. De drie cijfers achter de komma vormen samen het getal 125.",
          "1": "Je dacht waarschijnlijk dat je elk cijfer apart moest lezen. Maar bij kommagetallen lees je de cijfers achter de komma als één getal: 125 = honderdvijfentwintig, niet 'één twee vijf'. Onthoud: lees de cijfers achter de komma als één geheel getal.",
          "2": "Je dacht waarschijnlijk dat 125 hetzelfde is als 'twaalfeneenhalf'. Maar 125 = honderdvijfentwintig — lees het als één getal. Onthoud: 125 = honderd + vijfentwintig = honderdvijfentwintig.",
          "3": "Je dacht waarschijnlijk dat 0,125 een heel getal is. Maar 0,125 is een kommagetal kleiner dan 1. De 'nul' vóór de komma en de komma zelf zijn allebei belangrijk. Onthoud: als er een 0 vóór de komma staat, is het getal kleiner dan 1."
        }
      }
    },
    {
      "id": "GET-KOMMA-LEZEN-006",
      "familyId": "GET-KOMMA-LEZEN",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "komma_lezen_schrijven",
      "questionType": "ordering",
      "question": "Zet deze kommagetallen van klein naar groot:",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": ["0,8", "0,08", "0,18", "0,81"],
        "correctOrder": [1, 2, 0, 3]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kommagetallen vergelijken",
            "content": "Vergelijk cijfer voor cijfer achter de komma. 0,08 = 8 honderdsten. 0,18 = 18 honderdsten. 0,8 = 80 honderdsten. 0,81 = 81 honderdsten. Volgorde: 0,08 < 0,18 < 0,8 < 0,81.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "komma_ordenen",
      "variantIndex": 6,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.70,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Maak alle getallen even lang door nullen toe te voegen: 0,08 = 0,08; 0,18 = 0,18; 0,8 = 0,80; 0,81 = 0,81. Nu vergelijken: 08 < 18 < 80 < 81. Volgorde: 0,08 < 0,18 < 0,8 < 0,81.",
        "solutionSteps": [
          "Maak alle getallen even lang: 0,08 — 0,18 — 0,80 — 0,81",
          "Vergelijk de honderdsten: 08 < 18 < 80 < 81",
          "Volgorde: 0,08 < 0,18 < 0,8 < 0,81"
        ]
      }
    },
    {
      "id": "GET-KOMMA-LEZEN-007",
      "familyId": "GET-KOMMA-LEZEN",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "komma_lezen_schrijven",
      "questionType": "fill_in",
      "question": "Schrijf 'zeven komma nul drie' in cijfers.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["7,03", "7.03"],
        "caseSensitive": false,
        "placeholder": "Typ het getal..."
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kommagetal schrijven met nul",
            "content": "Splits bij 'komma'. Vóór de komma: 'zeven' = 7. Achter de komma: 'nul drie' = 03. De nul op de tiendenplek is belangrijk! Schrijf: 7,03.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "komma_woord_naar_cijfer_nul_fill",
      "variantIndex": 7,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.71,
      "pedagogy": { "dok": 1 },
      "feedback": {
        "explanationText": "Splits bij 'komma'. Vóór de komma: 'zeven' = 7. Achter de komma: 'nul drie' — de nul staat op de tiendenplek, de drie op de honderdstenplek. Schrijf: 7,03. Let op: 7,03 ≠ 7,3 (dat zou 'zeven komma drie' zijn).",
        "solutionSteps": [
          "Vóór de komma: 'zeven' = 7",
          "Achter de komma: 'nul drie' = 03",
          "De nul op de tiendenplek is belangrijk",
          "Schrijf: 7,03"
        ]
      }
    }
  ]
}